import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-semibold tracking-tight transition-all duration-150 ease-in-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border border-primary/25 bg-primary/10 text-primary hover:bg-primary/15 hover:border-primary/35 hover:shadow-xs",
        solid:
          "bg-primary text-primary-foreground hover:bg-primary/90 border border-primary/25 hover:shadow-xs",
        destructive:
          "border border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:border-destructive/40 hover:shadow-xs",
        outline:
          "border border-border bg-muted/35 text-foreground hover:border-primary/40 hover:bg-muted/80 hover:text-foreground hover:shadow-xs",
        secondary:
          "border border-transparent bg-secondary text-secondary-foreground hover:border-primary/40 hover:bg-muted/80 hover:text-foreground hover:shadow-xs",
        ghost:
          "border border-transparent text-foreground hover:border-primary/40 hover:bg-muted/80 hover:text-foreground hover:shadow-xs",
        link: "text-primary underline-offset-4 hover:underline active:scale-100",
      },
      size: {
        default: "h-11 px-5 py-2.5",
        sm: "h-9 px-3 text-xs",
        lg: "h-12 px-6 text-base",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
